'use strict';

module.exports = require('./jQueryXDomainRequestAjaxTransport');


//////////////////
// WEBPACK FOOTER
// ./node_modules/tscom-util/src/ie9ajaxshim.js
// module id = 239
// module chunks = 0